export default __webpack_public_path__ + "static/media/factory-visibility.e49f33e6.svg";